// extracted by mini-css-extract-plugin
module.exports = {"footerRoot":"Footer-module--footerRoot--2C2b7","footerContent":"Footer-module--footerContent--1Px89"};